// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ArrowRight from '../_raw/ui/icon_arrow_right.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ArrowRight);
